module.exports = __webpack_public_path__ + "img/civilizationHover.f8e110ba.png";